
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { Router } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import { Injectable, Inject, Injector } from '@angular/core';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';



import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppNavBarComponent } from './app-nav-bar/app-nav-bar.component';

// FEATURE MODULES
import { ProfilesModule } from './profiles/profiles.module';

// Local Components
import { SiteRootComponent } from './public/site-root/site-root.component';
import { SiteAboutComponent } from './public/site-about/site-about.component';
import { HtmlAudioComponent } from './shared/components/html-audio/html-audio.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { UnderConstructionComponent } from './shared/components/under-construction/under-construction.component';
import { MakeDraggableDirective } from './shared/directives/make-draggable.directive';
import { MakeDroppableDirective } from './shared/directives/make-droppable.directive';
import { MouseWheelDirective } from './shared/directives/mouse-wheel-directive.directive';
// LOCAL - THREEJS
import { ThreeDemoComponent } from './sandbox/three/three-demo/three-demo.component';

import { NgParticlesModule } from 'ng-particles';

// LOCAL -- ANIMATION.
import { AniFadeExampleComponent } from './sandbox/animation/ani-fade-example/ani-fade-example.component';
import { AniFlipExampleComponent } from './sandbox/animation/ani-flip-example/ani-flip-example.component';

// LOCAL HTML MEDIA.
import { HtmlAudioPlayerExampleComponent } from './sandbox/htmlAudio/html-audio-player-example/html-audio-player-example.component';
import { HtmlVideoRecorderExampleComponent } from './sandbox/htmlVideo/html-video-recorder-example/html-video-recorder-example.component';
import { HtmlVideoExampleComponent } from './sandbox/htmlVideo/html-video-example/html-video-example.component';
import { HtmlScrollWheelComponent } from './sandbox/htmlEvents/html-scroll-wheel/html-scroll-wheel.component';

import { GraphComponent } from './sandbox/d3/visuals/graph/graph.component';
import { LinkAnalysisExampleComponent } from './sandbox/d3/examples/link-analysis-example/link-analysis-example.component';
import { D3Service, D3_DIRECTIVES } from './sandbox/d3';
import { D3_SHARED_VISUALS } from './sandbox/d3/visuals/shared';
import { BarChartExampleComponent } from './sandbox/d3/examples/bar-chart-example/bar-chart-example.component';
import { PieV4Component } from './sandbox/d3/examples/pie-v4/pie-v4.component';
import { DonutV4Component } from './sandbox/d3/examples/donut-v4/donut-v4.component';
import { StarburstV4Component } from './sandbox/d3/examples/starburst-v4/starburst-v4.component';
import { PieV4ObjectsComponent } from './sandbox/d3/examples/pie-v4-objects/pie-v4-objects.component';
import { D3ExampleDataService } from './sandbox/d3/services/d3-example-data.service';
import { ScatterPlotV4Component } from './sandbox/d3/examples/scatter-plot-v4/scatter-plot-v4.component';
import { PieChartComponent } from './sandbox/d3/examples/pie-chart/pie-chart.component';
import { DataTestComponent } from './sandbox/data/data-test/data-test.component';
import { DynamicSVGComponent } from './sandbox/svg/dynamic-svg/dynamic-svg.component';
import { ParticleTestComponent } from './sandbox/tsParticles/particle-test/particle-test.component';


@NgModule({
  declarations: [
    AppComponent
    , AppNavBarComponent
    , SiteRootComponent
    , SiteAboutComponent
    , HtmlAudioPlayerExampleComponent
    , HtmlVideoRecorderExampleComponent
    , HtmlVideoExampleComponent
    , HtmlAudioComponent
    , HtmlScrollWheelComponent
    , PageNotFoundComponent
    , UnderConstructionComponent

    , MakeDraggableDirective
    , MakeDroppableDirective
    , MouseWheelDirective
    , ThreeDemoComponent
    , AniFadeExampleComponent
    , AniFlipExampleComponent

    , GraphComponent
    , D3_SHARED_VISUALS
    , D3_DIRECTIVES
    , PieChartComponent, LinkAnalysisExampleComponent, BarChartExampleComponent
    , PieV4Component, DonutV4Component, StarburstV4Component
    , PieV4ObjectsComponent, ScatterPlotV4Component, DataTestComponent, DynamicSVGComponent, ParticleTestComponent
  ],
  imports: [
    /* BUILT-IN */
    BrowserModule, BrowserAnimationsModule, HttpClientModule
    
    /* THIRD PARTY */
    , NgbModule
    , NgParticlesModule // NgParticlesModule is required
    /* FEATURES */
    //,ProfilesModule //<-- APP M
  
    /* ROUTING */
    , AppRoutingModule //<-- THIS NEEDS TO BE AT THE END.
  ],
  providers: [D3Service, D3ExampleDataService],
  bootstrap: [AppComponent]
})
export class AppModule { }
